ux-iws-sf-page {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    padding: 0;
    margin: 0;
    background-image: var(--ux-iws-sf-background-image, none);
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;

    &[variant="center-blue"] {
        padding: 60px calc(100% / 12);
    }
}
